module.exports = __webpack_public_path__ + "static/media/intro-background.38531f39.png";